import React, { Component } from 'react';
import style from './index.module.css';

class Chapter8 extends Component<any> {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      status,
      chargeCity,
      furthestCity,
      isMultiCar,
      rule
    } = this.props.data;
    const { setInstructionModel } = this.props;
    // if (status === 0) return;

    return (
      <div
        className={style.pageBox}
        style={{
          height: document.documentElement.clientHeight
        }}
      >
        {status === 1 && (
          <div className={style.itemBox} style={{ display: 'flex' }}>
            {isMultiCar && rule && (
              <div
                className={style.instructionsIconBox}
                onClick={() => setInstructionModel(rule)}
              />
            )}
            {/* <div className={style.xpIconBox} /> */}
            <p className={style.ordinaryText}>
              <span className={style.blueBigText}>
                2021年，我们一起
                <br />
                点亮了{chargeCity}座城市
              </span>
              <p className={style.blueNormalCityText}>
                你充过电的最远城市是
                <span className={style.blueNormalText}>{furthestCity}</span>
              </p>
              <br />
              <span className={style.grayNormalText}>
                2022年，陪你去看更远的风景
              </span>
            </p>
          </div>
        )}
        {status === 2 && (
          <div className={style.itemBox}>
            {/* <div className={style.instructionsIconBox} /> */}
            {isMultiCar && rule ? (
              <div
                className={style.instructionsIconBox}
                onClick={() => setInstructionModel(rule)}
              />
            ) : null}
            {/* <div className={style.xpIconBox} /> */}
            <p className={style.ordinaryText}>
              <span className={style.blueBigText}>
                2021年，我们一起
                <br />
                点亮了{chargeCity}座城市
              </span>
              <br />
              <span className={style.grayNormalText}>
                2022年，陪你去看更远的风景
              </span>
            </p>
          </div>
        )}
        <div className={style.chapter8Icon} />
      </div>
    );
  }
}

export default Chapter8;
